import { useContext } from "react";
import { OverflowFrame } from "../../../externalComponents";
import { PageHeading } from "../../../externalComponents/PageHeading";
import { SettingsSidebar } from "../../../externalComponents/SettingsSidebar";
import { Text } from "../../../externalComponents/tailwind/text";
import { CustomerContext } from "../../../providers";

export default function TwoFAPage() {
  const { customer } = useContext(CustomerContext);

  return (
    <>
      <SettingsSidebar>
        <PageHeading title="Two-Factor Authentication" />
        <OverflowFrame>
          {customer.is2faActivated ? (
            <Text className="mt-5">
              Two-factor authentication is currently enabled for your account.
              Your account is protected by WhatsApp verification, requiring a
              security code for each login attempt. This ensures that only you
              can access your account, even if someone knows your password.
            </Text>
          ) : (
            <Text className="mt-5">
              Two-factor authentication is not enabled for your account. For
              enhanced security, please contact our support team to enable this
              feature. This will add an extra layer of protection to your
              account by requiring a verification code sent via WhatsApp for
              each login.
            </Text>
          )}
        </OverflowFrame>
      </SettingsSidebar>
    </>
  );
}
